// extracted by mini-css-extract-plugin
export default {"container":"TitleModal_container__UHQ40","title":"TitleModal_title__M8C94","hint":"TitleModal_hint__WnxOC","descr":"TitleModal_descr__BVj0H"};